import React, { FC } from 'react';
import { Button } from '@mui/material';
import { setErrorApp } from '../../store/reducers/InfoSlice';
import { useAppDispatch } from '../../hooks/redux';
import { logoutUser } from '../../service/AuthService';
import styles from './logoutButton.module.css';

const LogoutButton: FC = () => {
	const dispatch = useAppDispatch();
	const logout = async () => {
		const response = await logoutUser();
		if (response.error) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при завершение сеанса',
				})
			);
		} else {
			window.location.replace(`/counter`);
		}
	};
	return (
		<div>
			<Button className={styles.button} onClick={logout}>
				Выйти
			</Button>
		</div>
	);
};

export default LogoutButton;
